/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayerVideo from './react-player-video';

interface VimeoVideoProps {
    videoId: string;
    onError: (errorMessage: string) => void;
}

const VimeoVideo: React.FC<VimeoVideoProps> = ({ videoId, onError }) => {
    if (!videoId) {
        onError('Vimeo video ID is empty');
        return null;
    }

    return (
        <ReactPlayerVideo
            url={`https://player.vimeo.com/video/${encodeURIComponent(
                videoId
            )}`}
        />
    );
};

export default VimeoVideo;
